import React from 'react';
import { Route, createRoutesFromElements } from 'react-router-dom';

import { ROOT, SHARE_ROUTE } from 'src/constants/routes';
import { PageLayout } from 'src/components/common/PageLayout';
import { Main } from 'src/components/pages/Main';
import { Result } from 'src/components/pages/Result';

export const Routes = (
  <>
    <Route element={<PageLayout />}>
      <Route path={ROOT} element={<Main />} />
      <Route path={SHARE_ROUTE} element={<Result />} />
    </Route>
  </>
);

export const routes = createRoutesFromElements(Routes);
export default routes;
